<h1 mat-dialog-title id="matches-dialog-header">
  <span>Potential Identity Matches</span>
  <div id="matches-dialog-instructions">Please review the following profiles and select a matching person or choose to create a new guest identity.</div>
</h1>

<mat-dialog-content class="match-container">
  @for (match of matches; track match) {
    <div class="match" [class.selected]="match == selectedMatch" (click)="selectMatch(match)">
      <div class="full-name">{{ match.fullName }}</div>
      <div class="birthdate">Birthdate: {{ match.birthdate | date }}</div>
      <div class="birthdate">I-Number: {{ match.iNumber }}</div>
      <div class="birthdate">School Email: {{ match.email }}</div>
      <div class="birthdate">Personal Email:{{ match.guestEmail }}</div>
      <div class="birthdate">Address: {{ match.address }}, {{ match.city }}, {{ match.state }} {{ match.postalCode }}</div>
    </div>
  }
  @if (matches.length == 0) {
    <div class="no-match">There are no BYU-Idaho accounts that match your search.</div>
  }
</mat-dialog-content>

<mat-dialog-actions class="action-container">
  <div>
    <button mat-button mat-raised-button class="secondary-button" [mat-dialog-close]>Cancel</button>
    <button mat-button mat-raised-button class="secondary-button" (click)="createNewIdentity()">Create New Identity</button>
  </div>
  <button mat-button mat-raised-button color="primary" (click)="selectExistingIdentity()" [disabled]="!selectedMatch">Select Existing Identity</button>
</mat-dialog-actions>
